import { getRegisterFunction } from '../../utils/register.js';
import { OneUxDistributionElement } from './OneUxDistributionElement.js';
export const register = getRegisterFunction(OneUxDistributionElement);
declare global {
  interface HTMLElementTagNameMap {
    'one-ux-distribution': OneUxDistributionElement;
    "distribution-d9079b74b6cc1f1d34105b088db8d651": OneUxDistributionElement;
  }
}